/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import React, {useState} from 'react'
import {IconButton} from '@mui/material'
import {MoreVert} from '@mui/icons-material'
import {Favorite} from '../../../../model/favorites'
import {FavoriteContextMenu} from './FavoriteContextMenu'

interface Props {
  favorite: Favorite
}

export const FavoriteContextMenuButton: React.FC<Props> = ({favorite}) => {
  const [favoriteMenuAnchor, setFavoriteMenuAnchor] = useState<Element>()

  return (
    <div data-testid={'FavoriteContextMenuButton:root'}>
      <IconButton
        onClick={(event: any) => {
          setFavoriteMenuAnchor(event.currentTarget)
        }}
        size='large'
      >
        <MoreVert />
      </IconButton>
      <FavoriteContextMenu
        anchorEl={favoriteMenuAnchor}
        setAnchorEl={setFavoriteMenuAnchor}
        favorite={favorite}
      />
    </div>
  )
}
